$(function(){
  $(window).on('load',function(){
    $('.world-slider').slick({
      autoplay: true,
      arrows: false,
      dots: true,
      centerMode: true,
      centerPadding: '20%',
    });
    
    // if(window.matchMedia("(max-width:767px)").matches){
    //   var slider = ".world_movie_main";
    //   var thumbnailItem = ".thumbnail-item";
    //   $(thumbnailItem).each(function(){
    //    var index = $(thumbnailItem).index(this);
    //    $(this).attr("data-index",index);
    //   });
    //   $(slider).on('init',function(slick){
    //    var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
    //    $(thumbnailItem+'[data-index="'+index+'"]').addClass("thumbnail-current");
    //   });
    //   $(slider).slick({
    //     autoplay: false,
    //     arrows: false,
    //     fade: true,
    //     infinite: false
    //   });
    //   $(thumbnailItem).on('click',function(){
    //     var index = $(this).attr("data-index");
    //     $(slider).slick("slickGoTo",index,false);
    //   });
    //   $(slider).on('beforeChange',function(event,slick, currentSlide,nextSlide){
    //     $(thumbnailItem).each(function(){
    //       $(this).removeClass("thumbnail-current");
    //     });
    //     $(thumbnailItem+'[data-index="'+nextSlide+'"]').addClass("thumbnail-current");
    //   });
    // } else {
    //   if(window.matchMedia("(min-width:768px)").matches){
    //     $(".world_movie_main").slick({
    //       asNavFor: ".world_movie_thumb",
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       fade: true,
    //       arrows: false
    //     });
    //     $(".world_movie_thumb").slick({
    //       asNavFor: ".world_movie_main",
    //       infinite: true,
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //       focusOnSelect: true,
    //     });
    //   }
    // }
    // function matchFunction(){
    //   location.reload();
    // }
    // window.matchMedia("(max-width:768px)").addListener(matchFunction);
    // window.matchMedia("(max-width:767px)").addListener(matchFunction);

  });

  $(".js_channel_main").slick({
    asNavFor: ".js_channel_thumb",
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false
  });
  $(".js_channel_thumb").slick({
    asNavFor: ".js_channel_main",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
  });

  $(".js_story_main").slick({
    asNavFor: ".js_story_thumb",
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false
  });
  $(".js_story_thumb").slick({
    asNavFor: ".js_story_main",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
  });



});

